import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';

import { Workspace } from 'src/components/types';
import { useIntl } from 'src/hooks/intl';
import { getCurrentWorkspace } from 'src/selectors/workspace-selectors';

type Props = {
  pageTitle: {
    id: string;
    description: string;
    defaultMessage: string;
  };
};

const WorkspaceHelmet = (props: Props) => {
  const workspace: Workspace | undefined = useSelector(getCurrentWorkspace);
  const intl = useIntl();

  if (workspace && workspace.slug) {
    const title = `${workspace.slug} / ${intl.formatMessage(props.pageTitle)}`;
    return <Helmet defer={false} title={title} />;
  }

  return null;
};

export default WorkspaceHelmet;
